import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { addNegativeToast } from 'modules/toastContainer';
import { get } from 'services/api';
import { FormField } from 'ui/formField';
import { Select } from 'ui/selectv2/Select';
import { BaseOption } from 'ui/selectv2/types';
import { spacing } from 'ui/theme';
import { useJsonEditorContext } from '../context/JsonEditorContext';
import { useDbConfigContext } from '../context/DbConfigContext';
import { dbConfigUrl } from '../constants';

export const EditorContainer = styled.div`
  border-radius: ${spacing.quarter};
  overflow: hidden;
`;

export const ConfigSelector = () => {
  const dispatchHook = useDispatch();
  const [selection, setSelection] = useState<BaseOption>();
  const { setName, setLastSavedJson } = useDbConfigContext();
  const { editor } = useJsonEditorContext();
  const [options, setOptions] = useState<BaseOption<string>[]>([]);
  const [error, setError] = useState<string>('');

  const onSelect = ([newOption]: BaseOption[]) => {
    setSelection(newOption);
    setName(newOption.value);
    get(`${dbConfigUrl}/${encodeURIComponent(newOption.value)}`)
      .then((config) => {
        editor.current?.setValue(JSON.stringify(config));
        setLastSavedJson(JSON.stringify(config));
      })
      .catch((err) => {
        // show error toast
        dispatchHook(addNegativeToast(`Selection failed (${err.message})`));
        // Clear JSON
        editor.current?.setValue('');
        setLastSavedJson('');
      });
  };

  useEffect(() => {
    get(dbConfigUrl)
      .then((configs) => {
        // populate options
        setOptions(configs.map((config: string) => ({ label: config, value: config })));
      })
      .catch((err) => {
        // show error toast
        dispatchHook(addNegativeToast(`Configuration list fetch failed (${err.message})`));
        setError('Configuration list fetch failed. Please refresh.');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormField
      inputId="adminDbConfigSelectName"
      labelText="Database config"
      isHorizontalLayout={true}
    >
      <Select
        usePortal
        data-test="admin-db-config-select-name"
        id="adminDbConfigSelectName"
        onSelect={onSelect}
        options={options}
        value={[selection]}
        errorMsg={error}
      />
    </FormField>
  );
};

export default ConfigSelector;
